import endpoints from "../models/api/api.endpoints";
import api from "../helpers/api.service";
import Helper from "../helpers/helper.service";
import ServiceResponseCode from "../models/service.response.code";

export default {
  async getDiciplinaLista(
  page = null,
  pageSize = null,
  disciplinaNome = null,
  modalidade = null,
  idCurso = null,
  idPeriodoLetivo = null,
  filtrarInstrutor = false,
  idFranqueadoUnidade = null
  ) {
    try {
      const params = [
        {
          Name: 'page',
          Value: page
        },
        {
          Name: 'pageSize',
          Value: pageSize
        },
        {
          Name: 'DisciplinaNome',
          Value: disciplinaNome
        },
        {
          Name: 'modalidade',
          Value: modalidade
        },
        {
          Name: 'idCurso',
          Value: idCurso
        },
        {
          Name: 'idPeriodoLetivo',
          Value: idPeriodoLetivo
        },
        {
          Name: 'filtrarInstrutor',
          Value: filtrarInstrutor
        },
        {
          Name: 'idFranqueadoUnidade',
          Value: idFranqueadoUnidade
        },
      ]
      const url = `${endpoints.disciplina}/list${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listaDisciplinasImportar(IdDisciplinaOrigem = null, idCurso = null) {
    try {
      const params = [
        {
          Name: 'IdDisciplinaOrigem',
          Value: IdDisciplinaOrigem
        },
        {
          Name: 'idCurso',
          Value: idCurso
        }
      ]
      const url = `${endpoints.disciplina}/lita-disciplinas-importar${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getDisciplina(id) {
    try {
      const url = `${endpoints.disciplina}/${id}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async registerDisciplina(data, method) {
    try {
      const result = (method == 'criar') ?
      await api.post(endpoints.disciplina, data) :
      await api.put(endpoints.disciplina, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async registerUsuarioDisciplina(data) {
    try {
      const url = `${endpoints.disciplina}/register-usuarios-disciplina`;
      const result = await api.put(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getNavegarDisciplina(id) {
    try {
      const url = `${endpoints.disciplina}/navegar-disciplina/${id}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async infoCopiaDisciplina(idDisciplina) {

    try {
      const url = `${endpoints.disciplina}/info-copia-disciplina/${idDisciplina}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }

  },
  async getAndamentoAtividades(idModulo = null, idAtividade = null) {
    try {
      const url = `${endpoints.disciplina}/andamento/${(idAtividade ? 'atividade' : 'modulo')}/${idAtividade ?? idModulo}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getAndamentoAulas(page, pageSize, idDisciplina, idModulo, idAula) {

    const params = [
      {
        Name: 'page',
        Value: page
      },
      {
        Name: 'pageSize',
        Value: pageSize
      },
      {
        Name: 'idDisciplina',
        Value: idDisciplina
      },
      {
        Name: 'idModulo',
        Value: idModulo
      },
      {
        Name: 'idAula',
        Value: idAula
      },
    ]

    try {
      const url = `${endpoints.disciplina}/andamento-aulas${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async removerAtividadeEmAndamento(idAtividade, idUsuario) {
    try {
      const params = [
        {
          Name: 'idAtividade',
          Value: idAtividade
        },
        {
          Name: 'idUsuario',
          Value: idUsuario
        },
      ]
      const url = `${endpoints.disciplina}/remover-atividade-em-andamento${Helper.getURLParams(params)}`;
      const result = await api.delete(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async removerAcompanhamentos(idDisciplina, idModulo, idAula) {
    try {
      const params = [
        {
          Name: 'idDisciplina',
          Value: idDisciplina
        },
        {
          Name: 'idModulo',
          Value: idModulo
        },
        {
          Name: 'idAula',
          Value: idAula
        },
      ]
      const url = `${endpoints.disciplina}/remover-acompanhamentos${Helper.getURLParams(params)}`;
      const result = await api.delete(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async copiarDisciplina(idOrigem, idDestino = null) {
    try {

      const params = [
        {
          Name: 'idOrigem',
          Value: idOrigem
        },
        {
          Name: 'idDestino',
          Value: idDestino
        },
      ]
      const url = `${endpoints.disciplina}/copiar-disciplina${Helper.getURLParams(params)}`;
      const result = await api.post(url, undefined, undefined, 300)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getUsuariosDisciplina(
    idDisciplina = null,
    idModulo = null,
    tipoPesquisa,
    pesquisa = null,
    page,
    pageSize
  ) {
    const params = [
      {
        Name: 'idDisciplina',
        Value: idDisciplina
      },
      {
        Name: 'idModulo',
        Value: idModulo
      },
      {
        Name: 'tipoPesquisa',
        Value: tipoPesquisa
      },
      {
        Name: 'pesquisa',
        Value: pesquisa
      },
      {
        Name: 'page',
        Value: page
      },
      {
        Name: 'pageSize',
        Value: pageSize
      },
    ]
    try {
      const url = `${endpoints.disciplina}/usuarios-disciplina${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async atividadesAdministrativo(
    idModalidade,
    idCurso = null,
    idPeriodoLetivo = null,
    idDisciplina = null,
    idUsuario = null,
    filtro,
    page,
    pageSize,
  ) {
    const params = [
      {
        Name: 'idModalidade',
        Value: idModalidade
      },
      {
        Name: 'idCurso',
        Value: idCurso
      },
      {
        Name: 'idPeriodoLetivo',
        Value: idPeriodoLetivo
      },
      {
        Name: 'idDisciplina',
        Value: idDisciplina
      },
      {
        Name: 'idUsuario',
        Value: idUsuario
      },
      {
        Name: 'filtro',
        Value: filtro
      },
      {
        Name: 'page',
        Value: page
      },
      {
        Name: 'pageSize',
        Value: pageSize
      },
    ]
    try {
      const url = `${endpoints.disciplina}/atividades/em-andamento${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async desbloquearAtividade(data) {
    try {
      const url = `${endpoints.disciplina}/atividades/desbloquear`;
      const result = await api.post(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },


}
